import { Backdrop as MUIBackdrop } from '@mui/material';
import type { SxProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { ReactNode } from 'react';
import { Spinner as DefaultSpinner } from '../Spinner/Spinner';

const Backdrop = styled(MUIBackdrop)(({ theme }) => ({
  position: 'absolute',
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
  borderRadius: theme.shape.borderRadius,
}));

interface Props {
  sx?: SxProps;
  spinner?: ReactNode;
  active: boolean;
}

export function Loader({ sx, spinner = <DefaultSpinner />, active }: Props) {
  if (!active) {
    return null;
  }

  return (
    <Backdrop open sx={sx}>
      {spinner}
    </Backdrop>
  );
}
